export default "__VITE_ASSET__9e9a0905__"